import React, { useState } from 'react';
import { certificateAPI } from '../api/documents';
import '../styles/DocumentForms.css';

function CreateCertificate() {
  const [formData, setFormData] = useState({
    name: '',
    college: '',
    domain: '',
    start_date: '',
    end_date: '',
    days: 30
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const result = await certificateAPI.create(formData);
      setSuccess(result);
      // Don't clear form immediately so user can see what they generated
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const downloadPDF = () => {
    if (success && success.id) {
      certificateAPI.downloadPDF(success.id);
    }
  };

  return (
    <div className="document-form-page">
      <div className="form-container">
        <h1 className="form-title">Certificate Engine</h1>
        <p className="form-subtitle">Generate Canva-powered credentials for Robolog Automation</p>

        {error && (
          <div className="alert alert-error">
            <strong>Error:</strong> {error}
          </div>
        )}

        {success && (
          <div className="alert alert-success">
            <div className="success-info">
              <strong>✔ Success!</strong> Certificate generated: <strong>{success.cert_id}</strong>
            </div>
            <div className="success-actions">
              <button onClick={downloadPDF} className="btn-download">
                📥 View Certificate
              </button>
              <button
                onClick={() => {
                  setSuccess(null);
                  setFormData({
                    name: '',
                    college: '',
                    domain: '',
                    start_date: '',
                    end_date: '',
                    days: 30
                  });
                }}
                className="btn-new"
              >
                🔄 Create New Certificate
              </button>
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit} className="document-form">
          <div className="form-group">
            <label htmlFor="name">Student Full Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="e.g. John Doe"
            />
          </div>

          <div className="form-group">
            <label htmlFor="college">College / University *</label>
            <input
              type="text"
              id="college"
              name="college"
              value={formData.college}
              onChange={handleChange}
              required
              placeholder="e.g. IIT Delhi"
            />
          </div>

          <div className="form-group">
            <label htmlFor="domain">Internship Domain *</label>
            <input
              type="text"
              id="domain"
              name="domain"
              value={formData.domain}
              onChange={handleChange}
              required
              placeholder="e.g. Embedded Systems & IoT"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="start_date">Start Date *</label>
              <input
                type="date"
                id="start_date"
                name="start_date"
                value={formData.start_date}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="end_date">End Date *</label>
              <input
                type="date"
                id="end_date"
                name="end_date"
                value={formData.end_date}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="days">Total Days *</label>
            <input
              type="number"
              id="days"
              name="days"
              value={formData.days}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? '⏳ Processing...' : '🚀 Generate Robolog Credential'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CreateCertificate;
